var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NNBrandIcon } from '@marketing-icons';
import Button from '@marketing/components/global/CTA/Button';
import Heading from '@marketing/components/global/typography/Heading';
import FlexSection from '@marketing/components/sections/FlexSection';
import { useMediaQuery } from '@mui/material';
import { addSubscriber } from '@third-party/iterable';
import { clsx } from 'clsx';
import { useState } from 'react';
import { validateEmailAddress } from '@utils/form_validations';
var signUpText = 'Sign up for Nom Comms to receive special offers, product sneak peeks and custom content created for devoted dog parents like you.';
function Newsletter(_a) {
    var _b = _a.flip, flip = _b === void 0 ? false : _b;
    var isMobile = useMediaQuery('(max-width: 768px)');
    var _c = useState(''), email = _c[0], setEmail = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState('Your email address'), placeholder = _e[0], setPlaceholder = _e[1];
    var _f = useState(null), error = _f[0], setError = _f[1];
    var _g = useState(null), suggestedEmail = _g[0], setSuggestedEmail = _g[1];
    var handleChange = function (e) {
        var newAddress = e.target.value;
        setEmail(newAddress);
        var _a = validateEmailAddress(newAddress), isValid = _a.isValid, suggestion = _a.suggestion;
        setSuggestedEmail(suggestion);
        if (!isValid) {
            setError('Please enter a valid email address.');
        }
        else {
            setError(null);
        }
    };
    var replaceEmail = function (e) {
        e.preventDefault();
        if (suggestedEmail) {
            setEmail(suggestedEmail);
            setSuggestedEmail(null);
            setError(null);
        }
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        setIsLoading(true);
        setSuggestedEmail(null);
        setError(null);
        if (email) {
            if (validateEmailAddress(email).isValid) {
                addSubscriber({
                    email: email,
                })
                    .then(function () {
                    setPlaceholder("You'll hear from us soon!");
                    setSuggestedEmail(null);
                })
                    .catch(function () {
                    setError('Something went wrong. Please try again.');
                })
                    .finally(function () {
                    setIsLoading(false);
                    setEmail('');
                });
            }
            else {
                setError('Please enter a valid email address.');
                setIsLoading(false);
            }
        }
    };
    var LogoBlock = (_jsxs("div", __assign({ className: "flex flex-col justify-center items-center gap-xl-m md:gap-[18px]" }, { children: [_jsx(Heading, __assign({ size: "sm" }, { children: "See what's new at" })), _jsx(NNBrandIcon, { className: "text-icon-dark w-[216px] h-[150px]" })] }), "LogoBlock"));
    var SignupBlock = (_jsxs("div", __assign({ className: "flex flex-col justify-center items-start gap-[15px] md:gap-xl-m text-sm-reg-m md:text-sm-reg-d w-full md:w-[503px]" }, { children: [_jsxs("form", __assign({ onSubmit: handleSubmit, className: clsx('flex justify-between items-center w-full gap-4', 'p-2xs-gutter md:p-xs-m', 'border border-shoe rounded-sm') }, { children: [_jsx("input", { id: "email", value: email, onChange: handleChange, disabled: isLoading, type: "text", "aria-label": "Your email address", placeholder: placeholder, className: "w-full flex-grow placeholder:text-state-inactive-dark pb-0 pt-0 pl-0 pr-0 border-0" }), _jsx(Button, { use: "primary", size: "tiny", label: "Submit", type: "submit", disabled: isLoading || !validateEmailAddress(email).isValid })] })), suggestedEmail && (_jsxs("p", __assign({ className: "text-xs-reg-m md:text-sm-reg-d italic" }, { children: ["Did you mean", ' ', _jsx("a", __assign({ onClick: replaceEmail, className: "underline cursor-pointer" }, { children: suggestedEmail })), "?"] }))), error && _jsx("p", __assign({ className: "text-error-red text-xs-reg-m md:text-sm-reg-d" }, { children: error })), _jsx("p", { children: signUpText }), _jsxs("p", { children: ["By continuing, you agree to receive special offers, product updates, news, and other marketing emails from Nom Nom and its Mars Petcare affiliates in accordance with our", ' ', _jsx("a", __assign({ href: "https://www.mars.com/privacy", target: "_blank", rel: "noopener noreferrer", className: "underline" }, { children: "Privacy Policy" })), ". You may unsubscribe at any time."] })] }), "SignupBlock"));
    var children = [LogoBlock, SignupBlock];
    return (_jsx(FlexSection, __assign({ backgroundColorStyle: "bg-surface-white", paddingStyle: "px-2xs-gutter py-lg-gutter md:px-2xl-gutter gap-xl-m", gapStyle: clsx(flip && 'md:gap-4xl-gutter'), flexStyle: clsx(flip && 'md:justify-start') }, { children: flip && !isMobile ? children.reverse() : children })));
}
export default Newsletter;
